import { render, staticRenderFns } from "./StockJournalRolesList.vue?vue&type=template&id=48be335b"
import script from "./StockJournalRolesList.vue?vue&type=script&lang=js"
export * from "./StockJournalRolesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports